import { render, staticRenderFns } from "./ModalAccountChangePassword.vue?vue&type=template&id=b8098ba6&scoped=true"
import script from "./ModalAccountChangePassword.vue?vue&type=script&lang=js"
export * from "./ModalAccountChangePassword.vue?vue&type=script&lang=js"
import style0 from "./ModalAccountChangePassword.vue?vue&type=style&index=0&id=b8098ba6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8098ba6",
  null
  
)

export default component.exports